
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{staticClass:"i-fill",attrs:{"cx":"36","cy":"16","r":"8","fill":"#D0EFEC"}}),_c('path',{staticClass:"i-Rectangle 34",attrs:{"stroke":"#234652","d":"M42 23.5V37H3V14h24.5"}}),_c('path',{staticClass:"i-Vector 9",attrs:{"stroke":"#234652","d":"M3 17.5 22.463 28 33.5 23"}}),_c('circle',{staticClass:"i-Ellipse 19",attrs:{"cx":"38","cy":"14","r":"7.5","stroke":"#234652"}}),_c('path',{staticClass:"i-Line 30",attrs:{"stroke":"#234652","d":"M38.5 10v5"}}),_c('path',{staticClass:"i-Line 31",attrs:{"stroke":"#234652","d":"M38.5 17v1"}})])
          )
        }
      }
    